import { Media } from '@/generated/graphql';

export enum MediaMimeRootType {
  VIDEO = 'video',
  IMAGE = 'image',
}

export interface ClientMedia {
  processedMedia: Media[];
  maskedMedia: Media[];
  originalMedia: Media[];
}
